import MissionsAPI from '~/services/api/MissionsAPI';
import {
  SET_MISSION_LABELS,
  CONFIRM_LABEL_SUGGESTION,
  SET_MEDIA_TOTAL,
  SET_LABELS_LOADING,
  EMPTY_LABELS_STORE,
} from '~/store/labels/mutation-types';

export async function fetchMissionLabels({ commit }, missionId) {
    try {
        commit(EMPTY_LABELS_STORE);
        commit(SET_LABELS_LOADING, true);
        const mission = await MissionsAPI.fetchMissionMetaGroups(missionId);
        const data = mission?.data ?? null;
        commit(SET_MISSION_LABELS, data);
        commit(SET_LABELS_LOADING, false);
        return Promise.resolve(data);
    } catch (error) {
        return Promise.reject(error);
    }
}

export async function setMediaTotal({ commit }, total) {
    commit(SET_MEDIA_TOTAL, total);
}

export async function confirmLabelSuggestion({ commit }, {
 mediaId, label, custom, suggestive, hasHero,
}) {
    commit(CONFIRM_LABEL_SUGGESTION, {
 mediaId, label, custom, suggestive, hasHero,
});
}

export async function saveLabels({ state, commit }, missionId) {
  commit(SET_LABELS_LOADING, true);
  const promisesCreate = [];
  const promisesAttach = [];
  state.medias.forEach(({
 id, label, custom, hasHero,
}) => {
      if (custom || hasHero) {
          // simply rename the media
          promisesCreate.push(MissionsAPI.createMetaForMedia(missionId, id, {
              origin: 'Manual',
              key: 'name',
              value: label,
              read_only: false,
          }));
      } else {
          // attach the label to the media
          promisesAttach.push(MissionsAPI.attachMetaToMedia(missionId, id, label.id));

          // rename the media
          promisesCreate.push(MissionsAPI.createMetaForMedia(missionId, id, {
              origin: 'Manual',
              key: 'name',
              value: label?.label,
              read_only: false,
          }));
      }
  });
  try {
    await Promise.all(promisesCreate);
    await Promise.all(promisesAttach);
    commit(SET_LABELS_LOADING, false);
    return Promise.resolve();
  } catch (error) {
    commit(SET_LABELS_LOADING, false);
    return Promise.reject(error);
  }
}
